import { SHOW_DOWNLOAD_DETAILS, HIDE_DOWNLOAD_DETAILS } from '../../constants/ActionTypes';

export function showDownloadDetails(uid) {
  return {
    type: SHOW_DOWNLOAD_DETAILS,
    result: { uid: uid },
  };
}

export function hideDownloadDetails() {
  return {
    type: HIDE_DOWNLOAD_DETAILS,
  };
}
